module.exports = __webpack_public_path__ + "img/IE.11c62e88.svg";